import { useStore } from '@utils';
import React, { FC } from 'react';
import { MembersStore } from '../../../store';
import { User } from '../../user';

export const WhoOption: FC = (option: number, isSelected: boolean) => {
  const membersStore = useStore(MembersStore);
  const member = membersStore.getMemberById(option);
  return (
    <User
      key={member.id}
      member={member}
      isSelected={isSelected}
      memberStatus={null}
    />
  );
};